import 'bootstrap/dist/css/bootstrap.min.css'
import './Header.css'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from "react-router-dom"
import User from "./user/User"
import { useState } from 'react'

function Header() {
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const handleClose = () => setShowOffcanvas(false);
    const handleOpen = () => setShowOffcanvas(true);

    return (
        <Navbar expand={'sm'}>
            <Navbar.Brand className='brand' href="/">SSHM4DAMS</Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${'sm'}`} className='hamburger' onClick={handleOpen} />
            <Navbar.Offcanvas
                show={showOffcanvas}
                onHide={handleClose}
                id={`offcanvasNavbar-expand-${'sm'}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${'sm'}`}
                placement="end"
                className='navbar-offcanvas'
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${'sm'}`} className='navbar-offcanvas-title'>
                        SSHM4DAMS
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body >
                    <Nav className="mx-auto" >
                        <Nav.Link className='navlink' as={Link} to="/" onClick={handleClose}>Home</Nav.Link>
                        <Nav.Link className='navlink' as={Link} to="/map" onClick={handleClose}>Map</Nav.Link>
                        <Nav.Link className='navlink' as={Link} to="/about" onClick={handleClose}>About</Nav.Link>
                        <Nav.Link className='navlink' as={Link} to="/team" onClick={handleClose}>Team</Nav.Link>
                        <Nav.Link className='navlink' as={Link} to="/publications" onClick={handleClose}>Publications</Nav.Link>
                        <Nav.Link className='navlink' as={Link} to="/data-sharing" onClick={handleClose}>Data-Sharing</Nav.Link>
                    </Nav >
                    <div className='ml-auto'>
                        <User />
                    </div>
                </Offcanvas.Body>
            </Navbar.Offcanvas>
        </Navbar >
    )
}

export default Header